'use client'

import React from 'react'

const ProgressSteps = ({ currentStep = 1 }) => {
  const steps = [
    '製品の特定',
    '下取り申請フォームの提出',
    '「下取り申請内容の確認完了のご案内」メールの受信と下取り製品の発送',
  ]

  return (
    <div className="flex justify-center mb-8 lg:mb-12">
      {/* Desktop Progress Steps */}
      <div className="hidden lg:grid lg:grid-cols-3 lg:gap-20 w-full max-w-5xl px-4 text-center">
        {steps.map((step, index) => (
          <div
            key={`desktop-step-${index}`}
            className={`flex ${index === 0 ? 'justify-end' : index === 2 ? 'justify-start' : 'justify-center'} items-center`}
          >
            <div
              className={`min-w-5 min-h-5 ${currentStep === index + 1 ? 'bg-black' : 'bg-gray-300'} text-white rounded-full flex items-center justify-center text-sm ${currentStep === index + 1 ? 'font-bold' : ''}`}
            >
              {index + 1}
            </div>
            <span
              className={`ml-2 text-sm ${currentStep === index + 1 ? 'font-extrabold' : 'text-gray-500'}`}
            >
              {step}
            </span>
          </div>
        ))}
      </div>

      {/* Mobile Progress Steps */}
      <div className="lg:hidden flex justify-center items-center space-x-4 w-full">
        {steps.map((step, index) => (
          <div
            key={`mobile-step-${index}`}
            className="flex items-center w-[calc(100%_/_3_-_28px)] justify-center"
          >
            <div
              className={`w-5 h-5 ${currentStep === index + 1 ? 'bg-black' : 'bg-gray-300'} text-white rounded-full flex items-center justify-center text-xs ${currentStep === index + 1 ? 'font-bold' : ''} flex-shrink-0`}
            >
              {index + 1}
            </div>
            <span
              className={`ml-1 text-xs ${currentStep === index + 1 ? 'font-extrabold' : 'text-gray-500'} ${index === 1 || index === 2 ? 'whitespace-normal break-words' : 'whitespace-nowrap'}`}
            >
              {step}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProgressSteps
